<template>
    <div class="leitura-qrcode-page">
        <div class="leitura-qrcode-container">
            <header class="page-header">
                <div class="page-titulo">
                    <i class="pi pi-qrcode"></i>
                    <h1>Leitura de QRCode</h1>
                </div>
                <p class="page-subtitulo">
                    {{ etapa === 'configuracao' ? 'Leia o QRCode de configuração do evento' : 'Checkin de participantes do evento' }}
                </p>
            </header>

            <main class="page-content">
                <div v-if="etapa === 'configuracao'" class="leitor-area">
                    <div class="leitor-instrucao">
                        <i class="pi pi-info-circle"></i>
                        <span>Aponte o QRCode de <strong>configuração</strong> para a câmera. Ele carregará os dados do evento automaticamente.</span>
                    </div>
                    <div class="leitor-wrapper">
                        <qrcode-stream :camera="camera" @decode="onDecodeConfiguracao" @init="onInit" />
                        <div class="leitor-mira leitor-mira-config"></div>
                        <div v-if="processandoConfiguracao" class="leitor-overlay">
                            <ProgressSpinner style="width: 60px; height: 60px" strokeWidth="4" />
                            <span>Carregando configuração...</span>
                        </div>
                    </div>
                    <div class="leitor-acoes">
                        <SebraeButton label="Trocar câmera" icon="pi pi-refresh" variant="secondary" class="btn-trocar-camera" @click="alternarCamera()" />
                    </div>
                </div>

                <template v-else>
                    <div class="config-painel">
                        <div class="config-header">
                            <div class="config-header-icone">
                                <i class="pi pi-check"></i>
                            </div>
                            <div class="config-header-texto">
                                <div class="config-titulo">Configuração carregada</div>
                                <div class="config-sub">
                                    {{ eventos.length }} evento{{ eventos.length > 1 ? 's' : '' }} disponíve{{ eventos.length > 1 ? 'is' : 'l' }}
                                </div>
                            </div>
                        </div>

                        <div class="dropdown-bloco">
                            <label class="dropdown-label" for="dropdownEvento">
                                <i class="pi pi-calendar"></i>
                                <span>Evento ativo</span>
                            </label>
                            <Dropdown
                                id="dropdownEvento"
                                v-model="eventoSelecionado"
                                :options="eventos"
                                optionLabel="nomeEvento"
                                dataKey="codEvento"
                                placeholder="Selecione o evento"
                                class="dropdown-evento"
                                appendTo="self"
                            >
                                <template #value="slotProps">
                                    <div v-if="slotProps.value" class="dropdown-item dropdown-item--value">
                                        <span class="dropdown-codigo">{{ slotProps.value.codEvento }}</span>
                                        <span class="dropdown-nome">{{ slotProps.value.nomeEvento }}</span>
                                    </div>
                                    <span v-else class="dropdown-placeholder">{{ slotProps.placeholder }}</span>
                                </template>
                                <template #option="slotProps">
                                    <div class="dropdown-item">
                                        <div class="dropdown-item-topo">
                                            <span class="dropdown-codigo">{{ slotProps.option.codEvento }}</span>
                                            <span class="dropdown-periodo" v-if="formatarPeriodo(slotProps.option)">
                                                <i class="pi pi-clock"></i>
                                                {{ formatarPeriodo(slotProps.option) }}
                                            </span>
                                        </div>
                                        <span class="dropdown-nome">{{ slotProps.option.nomeEvento }}</span>
                                    </div>
                                </template>
                            </Dropdown>
                        </div>

                        <button type="button" class="btn-reconfigurar" @click="reiniciarConfiguracao()">
                            <span class="btn-reconfigurar-icone">
                                <i class="pi pi-replay"></i>
                            </span>
                            <span class="btn-reconfigurar-texto">
                                <span class="btn-reconfigurar-titulo">Reconfigurar</span>
                                <span class="btn-reconfigurar-sub">Ler novo QRCode de configuração</span>
                            </span>
                            <i class="pi pi-chevron-right btn-reconfigurar-chevron"></i>
                        </button>
                    </div>

                    <div v-if="eventoSelecionado" class="leitor-area">
                        <div class="leitor-instrucao">
                            <i class="pi pi-info-circle"></i>
                            <span>Aponte o QRCode do participante. O checkin será registrado em <strong>{{ eventoSelecionado.nomeEvento }}</strong>.</span>
                        </div>
                        <div class="leitor-wrapper">
                            <qrcode-stream :camera="camera" @decode="onDecodeCheckin" @init="onInit" />
                            <div class="leitor-mira"></div>
                            <div v-if="processandoCheckin" class="leitor-overlay">
                                <ProgressSpinner style="width: 60px; height: 60px" strokeWidth="4" />
                                <span>Processando...</span>
                            </div>
                        </div>
                        <div class="leitor-acoes">
                            <SebraeButton label="Trocar câmera" icon="pi pi-refresh" variant="secondary" class="btn-trocar-camera" @click="alternarCamera()" />
                        </div>
                    </div>
                </template>
            </main>
        </div>

        <SebraeModal v-model:visible="modalInfo.visivel" :title="modalInfo.titulo" size="sm" confirm-label="Entendi" :show-cancel="false" @confirm="fecharModalInfo">
            <div class="text-center">
                <i :class="['text-4xl mb-3 block', modalInfo.icone]" :style="{ color: modalInfo.cor }" aria-hidden="true"></i>
                <p class="m-0 line-height-3" v-html="modalInfo.mensagem"></p>
            </div>
        </SebraeModal>
    </div>
</template>

<script>
import { QrcodeStream } from 'vue3-qrcode-reader';
import service from './services';

const ORIGEM_API = 2;

export default {
    components: { QrcodeStream },

    data() {
        return {
            etapa: 'configuracao',

            configuracao: null,
            eventos: [],
            eventoSelecionado: null,

            camera: 'auto',
            processandoConfiguracao: false,
            processandoCheckin: false,

            modalInfo: {
                visivel: false,
                titulo: '',
                mensagem: '',
                icone: 'pi pi-info-circle',
                cor: '#0d4b8a',
                aoFechar: null,
                autoFecharTimeout: null,
            },
        };
    },

    beforeUnmount() {
        if (this.modalInfo.autoFecharTimeout) {
            clearTimeout(this.modalInfo.autoFecharTimeout);
        }
    },

    methods: {
        alternarCamera() {
            this.camera = this.camera === 'auto' ? 'rear' : this.camera === 'rear' ? 'front' : 'auto';
        },

        onInit(promise) {
            promise.catch(() => {
                this.exibirInfo({
                    severidade: 'error',
                    titulo: 'Erro na câmera',
                    mensagem: 'Não foi possível acessar a câmera. Verifique as permissões do navegador.',
                });
            });
        },

        reiniciarConfiguracao() {
            this.etapa = 'configuracao';
            this.eventoSelecionado = null;
        },

        formatarPeriodo(evento) {
            if (!evento) return '';
            const formatar = (data) => {
                if (!data) return '';
                if (this.$moment) {
                    const m = this.$moment(data, ['DD/MM/YYYY', 'YYYY-MM-DD', this.$moment.ISO_8601], true);
                    if (m.isValid()) return m.format('DD/MM/YYYY');
                }
                return data;
            };
            const inicio = formatar(evento.dataInicio);
            const fim = formatar(evento.dataFim);
            if (inicio && fim && inicio !== fim) return `${inicio} a ${fim}`;
            return inicio || fim || '';
        },

        onDecodeConfiguracao(decodedString) {
            if (this.processandoConfiguracao) return;
            this.processandoConfiguracao = true;

            try {
                const conteudo = (decodedString || '').toString().trim();
                if (!conteudo) {
                    throw new Error('QRCode vazio.');
                }

                const dados = JSON.parse(conteudo);
                const eventosBrutos = dados?.eventos || dados?.Eventos;
                if (!dados || !Array.isArray(eventosBrutos) || eventosBrutos.length === 0) {
                    throw new Error('QRCode não contém eventos válidos.');
                }

                const limpar = (valor) => (typeof valor === 'string' ? valor.trim() : valor);

                this.configuracao = {
                    urlAutenticacao: limpar(dados.urlAutenticacao ?? dados.UrlAutenticacao),
                    urlServico: limpar(dados.urlServico ?? dados.UrlServico),
                    urlPortal: limpar(dados.urlPortal ?? dados.UrlPortal),
                    urlImpressao: limpar(dados.urlImpressao ?? dados.UrlImpressao),
                    usuario: limpar(dados.usuario ?? dados.Usuario),
                    senha: limpar(dados.senha ?? dados.Senha),
                };
                this.eventos = eventosBrutos.map((e) => ({
                    codEvento: limpar(e.codEvento ?? e.CodEvento),
                    nomeEvento: limpar(e.nomeEvento ?? e.NomeEvento),
                    dataInicio: limpar(e.dataInicio ?? e.DataInicio),
                    dataFim: limpar(e.dataFim ?? e.DataFim),
                }));
                this.eventoSelecionado = this.eventos[0];
                this.etapa = 'checkin';

                this.exibirInfo({
                    severidade: 'success',
                    titulo: 'Configuração carregada',
                    mensagem: `${this.eventos.length} evento(s) disponível(eis). Selecione no dropdown e comece a leitura dos checkins.`,
                    autoFechar: 3500,
                });
            } catch (erro) {
                this.exibirInfo({
                    severidade: 'error',
                    titulo: 'QRCode de configuração inválido',
                    mensagem: erro?.message || 'Não foi possível interpretar o conteúdo do QRCode.',
                });
            } finally {
                setTimeout(() => {
                    this.processandoConfiguracao = false;
                }, 600);
            }
        },

        obterDataLeituraAtual() {
            const hoje = new Date();
            const ano = hoje.getFullYear();
            const mes = String(hoje.getMonth() + 1).padStart(2, '0');
            const dia = String(hoje.getDate()).padStart(2, '0');
            return `${ano}-${mes}-${dia}`;
        },

        onDecodeCheckin(decodedString) {
            if (this.processandoCheckin) return;
            if (!this.eventoSelecionado) {
                this.exibirInfo({
                    severidade: 'warn',
                    titulo: 'Selecione um evento',
                    mensagem: 'Escolha um evento no dropdown antes de bipar o QRCode.',
                    autoFechar: 3500,
                });
                return;
            }

            const qrCode = (decodedString || '').toString().trim();
            if (!qrCode) {
                this.exibirInfo({
                    severidade: 'error',
                    titulo: 'QRCode inválido',
                    mensagem: 'Não foi possível ler o conteúdo do QRCode.',
                    autoFechar: 4000,
                });
                return;
            }

            this.enviarCheckin(qrCode);
        },

        enviarCheckin(qrCode) {
            this.processandoCheckin = true;
            this.$store.dispatch('addRequest');

            const payload = {
                codigoEvento: this.eventoSelecionado.codEvento,
                qrCode,
                dataLeitura: this.obterDataLeituraAtual(),
                origem: ORIGEM_API,
            };

            service
                .inserirCheckin(payload)
                .then((response) => {
                    if (response?.success) {
                        this.exibirInfo({
                            severidade: 'success',
                            titulo: 'Checkin registrado',
                            mensagem: `Checkin registrado em <strong>${this.eventoSelecionado.nomeEvento}</strong> (${this.eventoSelecionado.codEvento}).`,
                            autoFechar: 4000,
                        });
                    } else {
                        const mensagem = (response?.errors && response.errors.join('<br>')) || 'Não foi possível registrar o checkin.';
                        this.exibirInfo({
                            severidade: 'error',
                            titulo: 'Falha no checkin',
                            mensagem,
                        });
                    }
                })
                .catch(() => {
                    this.exibirInfo({
                        severidade: 'error',
                        titulo: 'Falha no checkin',
                        mensagem: 'Ocorreu um erro ao registrar o checkin. Tente novamente.',
                    });
                })
                .finally(() => {
                    this.processandoCheckin = false;
                    this.$store.dispatch('removeRequest');
                });
        },

        exibirInfo({ titulo, mensagem, severidade = 'info', autoFechar = 0, aoFechar = null }) {
            const presets = {
                success: { icone: 'pi pi-check-circle', cor: '#1e8e3e' },
                error: { icone: 'pi pi-times-circle', cor: '#c62828' },
                warn: { icone: 'pi pi-exclamation-triangle', cor: '#b8860b' },
                info: { icone: 'pi pi-info-circle', cor: '#0d4b8a' },
            };
            const preset = presets[severidade] || presets.info;

            if (this.modalInfo.autoFecharTimeout) {
                clearTimeout(this.modalInfo.autoFecharTimeout);
                this.modalInfo.autoFecharTimeout = null;
            }

            this.modalInfo = {
                visivel: true,
                titulo: titulo || '',
                mensagem: mensagem || '',
                icone: preset.icone,
                cor: preset.cor,
                aoFechar,
                autoFecharTimeout: null,
            };

            if (autoFechar > 0) {
                this.modalInfo.autoFecharTimeout = setTimeout(() => {
                    this.fecharModalInfo();
                }, autoFechar);
            }
        },

        fecharModalInfo() {
            if (this.modalInfo.autoFecharTimeout) {
                clearTimeout(this.modalInfo.autoFecharTimeout);
            }
            const callback = this.modalInfo.aoFechar;
            this.modalInfo = {
                visivel: false,
                titulo: '',
                mensagem: '',
                icone: 'pi pi-info-circle',
                cor: '#0d4b8a',
                aoFechar: null,
                autoFecharTimeout: null,
            };
            if (typeof callback === 'function') {
                callback();
            }
        },
    },
};
</script>

<style scoped>
.leitura-qrcode-page {
    position: fixed;
    inset: 0;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    background: linear-gradient(160deg, #0a2a5e 0%, #0d4b8a 45%, #1f6fc4 100%);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    color: #fff;
    padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
}

.leitura-qrcode-container {
    width: 100%;
    max-width: 640px;
    margin: 0 auto;
    padding: 1.5rem 1rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    box-sizing: border-box;
}

.page-header {
    text-align: center;
    color: #fff;
}

.page-titulo {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
}

.page-titulo i {
    font-size: 1.6rem;
}

.page-titulo h1 {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 700;
    letter-spacing: 0.3px;
}

.page-subtitulo {
    margin: 0.25rem 0 0;
    font-size: 0.9rem;
    opacity: 0.85;
}

.page-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    width: 100%;
}

.config-painel {
    width: 100%;
    max-width: 480px;
    background: linear-gradient(160deg, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0.08) 100%);
    border: 1px solid rgba(255, 255, 255, 0.32);
    border-radius: 18px;
    padding: 1.15rem 1.15rem 1rem;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
}

.config-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.config-header-icone {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.45);
}

.config-header-icone i {
    font-size: 1.05rem;
    font-weight: 700;
}

.config-header-texto {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
}

.config-titulo {
    font-weight: 700;
    font-size: 1rem;
    color: #fff;
}

.config-sub {
    font-size: 0.8rem;
    opacity: 0.85;
    margin-top: 0.15rem;
}

.dropdown-bloco {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
}

.dropdown-label {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    opacity: 0.92;
}

.dropdown-label i {
    font-size: 0.85rem;
    opacity: 0.85;
}

.dropdown-evento {
    width: 100%;
}

.dropdown-evento :deep(.p-dropdown) {
    width: 100%;
    background: #fff;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
    transition: box-shadow 0.2s, transform 0.1s;
}

.dropdown-evento :deep(.p-dropdown:not(.p-disabled):hover) {
    border-color: rgba(255, 255, 255, 0.7);
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.22);
}

.dropdown-evento :deep(.p-dropdown:not(.p-disabled).p-focus) {
    box-shadow: 0 0 0 3px rgba(124, 220, 255, 0.45), 0 8px 22px rgba(0, 0, 0, 0.22);
    border-color: #7cdcff;
}

.dropdown-evento :deep(.p-dropdown .p-dropdown-label) {
    padding: 0.65rem 0.9rem;
    color: #1e293b;
}

.dropdown-evento :deep(.p-dropdown .p-dropdown-trigger) {
    color: #0d4b8a;
    width: 2.5rem;
}

.dropdown-evento :deep(.p-dropdown-panel) {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(13, 75, 138, 0.15);
}

.dropdown-evento :deep(.p-dropdown-panel .p-dropdown-item) {
    padding: 0.7rem 0.9rem;
    border-bottom: 1px solid rgba(13, 75, 138, 0.08);
}

.dropdown-evento :deep(.p-dropdown-panel .p-dropdown-item:last-child) {
    border-bottom: none;
}

.dropdown-evento :deep(.p-dropdown-panel .p-dropdown-item.p-highlight) {
    background: linear-gradient(135deg, rgba(13, 75, 138, 0.1) 0%, rgba(31, 111, 196, 0.12) 100%);
    color: #0d4b8a;
}

.dropdown-item {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    line-height: 1.25;
    width: 100%;
}

.dropdown-item--value {
    gap: 0.1rem;
}

.dropdown-item-topo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.dropdown-codigo {
    display: inline-block;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.6px;
    color: #0d4b8a;
    background: rgba(13, 75, 138, 0.12);
    padding: 0.15rem 0.5rem;
    border-radius: 999px;
}

.dropdown-nome {
    font-weight: 600;
    color: #1e293b;
    font-size: 0.95rem;
}

.dropdown-periodo {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.72rem;
    color: #64748b;
    background: #f1f5f9;
    padding: 0.15rem 0.5rem;
    border-radius: 999px;
}

.dropdown-periodo i {
    font-size: 0.7rem;
}

.dropdown-placeholder {
    color: #94a3b8;
}

.btn-reconfigurar {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    padding: 0.7rem 0.85rem;
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    border: 1px dashed rgba(255, 255, 255, 0.45);
    border-radius: 12px;
    cursor: pointer;
    text-align: left;
    font-family: inherit;
    transition: background-color 0.2s, border-color 0.2s, transform 0.1s, box-shadow 0.2s;
}

.btn-reconfigurar:hover,
.btn-reconfigurar:focus-visible {
    background: rgba(255, 255, 255, 0.16);
    border-color: rgba(255, 255, 255, 0.75);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
    outline: none;
}

.btn-reconfigurar:active {
    transform: scale(0.99);
}

.btn-reconfigurar-icone {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}

.btn-reconfigurar-icone i {
    font-size: 0.9rem;
}

.btn-reconfigurar-texto {
    flex: 1;
    display: flex;
    flex-direction: column;
    line-height: 1.2;
}

.btn-reconfigurar-titulo {
    font-weight: 700;
    font-size: 0.92rem;
}

.btn-reconfigurar-sub {
    font-size: 0.75rem;
    opacity: 0.85;
    margin-top: 0.1rem;
}

.btn-reconfigurar-chevron {
    opacity: 0.7;
    font-size: 0.8rem;
    transition: transform 0.15s, opacity 0.15s;
}

.btn-reconfigurar:hover .btn-reconfigurar-chevron {
    opacity: 1;
    transform: translateX(2px);
}

.leitor-area {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    width: 100%;
}

.leitor-instrucao {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    padding: 0.7rem 0.9rem;
    font-size: 0.88rem;
    line-height: 1.35;
    max-width: 480px;
    text-align: left;
}

.leitor-instrucao i {
    font-size: 1.1rem;
    flex-shrink: 0;
}

.leitor-wrapper {
    position: relative;
    width: 100%;
    max-width: 480px;
    aspect-ratio: 1 / 1;
    border-radius: 18px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
    background: #000;
    border: 2px solid rgba(255, 255, 255, 0.25);
}

.leitor-wrapper :deep(video),
.leitor-wrapper :deep(canvas) {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
}

.leitor-mira {
    position: absolute;
    inset: 12%;
    border: 2px solid rgba(255, 255, 255, 0.7);
    border-radius: 16px;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.18);
    pointer-events: none;
    z-index: 2;
}

.leitor-mira-config {
    border-color: rgba(124, 220, 255, 0.85);
}

.leitor-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 600;
    z-index: 5;
}

.leitor-acoes {
    display: flex;
    gap: 0.5rem;
    width: 100%;
    max-width: 480px;
    justify-content: center;
}

.leitor-acoes .btn-trocar-camera {
    background: rgba(255, 255, 255, 0.12) !important;
    color: #fff !important;
    border-color: rgba(255, 255, 255, 0.55) !important;
}

.leitor-acoes .btn-trocar-camera:hover {
    background: rgba(255, 255, 255, 0.22) !important;
}

.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 1rem;
}

.modal {
    background: #fff;
    border-radius: 14px;
    max-width: 480px;
    width: 100%;
    box-shadow: 0 14px 36px rgba(0, 0, 0, 0.35);
    color: #1e293b;
}

.modal-content {
    padding: 1.75rem 1.5rem;
    text-align: center;
}

.modal-info-icone {
    font-size: 3.5rem;
    margin-bottom: 0.6rem;
    display: block;
}

.modal-titulo {
    margin: 0 0 0.4rem;
    font-size: 1.25rem;
    font-weight: 700;
    color: #1e293b;
}

.modal-texto {
    color: #475569;
    margin: 0 0 1rem;
    line-height: 1.45;
    font-size: 0.95rem;
}

.modal-acoes {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: center;
    margin-top: 1rem;
}

@media (max-width: 480px) {
    .leitura-qrcode-container {
        padding: 1rem 0.85rem 1.5rem;
        gap: 1rem;
    }

    .page-titulo h1 {
        font-size: 1.2rem;
    }

    .page-titulo i {
        font-size: 1.4rem;
    }

    .page-subtitulo {
        font-size: 0.82rem;
    }

    .leitor-instrucao,
    .config-painel {
        font-size: 0.82rem;
    }

    .modal-content {
        padding: 1.5rem 1.1rem;
    }

    .modal-info-icone {
        font-size: 3rem;
    }

    .modal-titulo {
        font-size: 1.1rem;
    }
}

@media (max-height: 640px) and (orientation: landscape) {
    .leitor-wrapper {
        max-width: 320px;
    }
}
</style>
